import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { VersionsService } from '../../services/VersionsService';
import { Versions } from '../../models/Versions';

@Directive ({
	selector: '[appVersionGreater]',
	standalone: false,
})
export class AppVersionGreaterDirective {

	private _authorized: boolean;
	private _versions: Versions;

	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainerRef: ViewContainerRef,
		versionsService: VersionsService
	) {
		this._versions = versionsService.versions;
	}

	@Input() set appVersionGreater(version: string) {
		if (version) {
			if (this._versions.GreaterThanAppVersion(version)) {
				if (!this._authorized) {
					this.viewContainerRef.createEmbeddedView(this.templateRef);
				}
				this._authorized = true;
			} else if (this._authorized) {
				this.viewContainerRef.clear();
				this._authorized = false;
			}
		}
	}
}

@Directive ({
	selector: '[appVersionEqual]',
	standalone: false,
})
export class AppVersionEqualDirective {

	private _authorized: boolean;
	private _versions: Versions;

	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainerRef: ViewContainerRef,
		versionsService: VersionsService
	) {
		this._versions = versionsService.versions;
	}

	@Input() set appVersionEqual(version: string) {
		if (version) {
			if (this._versions.EqualToAppVersion(version)) {
				if (!this._authorized) {
					this.viewContainerRef.createEmbeddedView(this.templateRef);
				}
				this._authorized = true;
			} else if (this._authorized) {
				this.viewContainerRef.clear();
				this._authorized = false;
			}
		}
	}
}

@Directive ({
	selector: '[appVersionLessThan]',
	standalone: false,
})
export class AppVersionLessThanDirective {

	private _authorized: boolean;
	private _versions: Versions;

	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainerRef: ViewContainerRef,
		versionsService: VersionsService
	) {
		this._versions = versionsService.versions;
	}

	@Input() set appVersionLessThan(version: string) {
		if (version) {
			if (this._versions.LessThanAppVersion(version)) {
				if (!this._authorized) {
					this.viewContainerRef.createEmbeddedView(this.templateRef);
				}
				this._authorized = true;
			} else if (this._authorized) {
				this.viewContainerRef.clear();
				this._authorized = false;
			}
		}
	}
}

@Directive ({
	selector: '[cmsVersionGreater]',
	standalone: false,
})
export class ServerVersionGreaterDirective {

	private _authorized: boolean;
	private _versions: Versions;

	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainerRef: ViewContainerRef,
		versionsService: VersionsService
	) {
		this._versions = versionsService.versions;
	}

	@Input() set cmsVersionGreater(version: string) {
		if (version) {
			if (this._versions.GreaterThanServerVersion(version)) {
				if (!this._authorized) {
					this.viewContainerRef.createEmbeddedView(this.templateRef);
				}
				this._authorized = true;
			} else if (this._authorized) {
				this.viewContainerRef.clear();
				this._authorized = false;
			}
		}
	}
}

@Directive ({
	selector: '[cmsVersionEqual]',
	standalone: false,
})
export class ServerVersionEqualDirective {

	private _authorized: boolean;
	private _versions: Versions;

	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainerRef: ViewContainerRef,
		versionsService: VersionsService
	) {
		this._versions = versionsService.versions;
	}

	@Input() set cmsVersionEqual(version: string) {
		if (version) {
			if (this._versions.EqualToServerVersion(version)) {
				if (!this._authorized) {
					this.viewContainerRef.createEmbeddedView(this.templateRef);
				}
				this._authorized = true;
			} else if (this._authorized) {
				this.viewContainerRef.clear();
				this._authorized = false;
			}
		}
	}
}

@Directive ({
	selector: '[cmsVersionLessThan]',
	standalone: false,
})
export class ServerVersionLessThanDirective {

	private _authorized: boolean;
	private _versions: Versions;

	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainerRef: ViewContainerRef,
		versionsService: VersionsService
	) {
		this._versions = versionsService.versions;
	}

	@Input() set cmsVersionLessThan(version: string) {
		if (version) {
			if (this._versions.LessThanServerVersion(version)) {
				if (!this._authorized) {
					this.viewContainerRef.createEmbeddedView(this.templateRef);
				}
				this._authorized = true;
			} else if (this._authorized) {
				this.viewContainerRef.clear();
				this._authorized = false;
			}
		}
	}
}
